module.exports = wp.data;